import styles from "./index.module.less";
const H5Component = () => {
  return (
    <div className={`${styles.H5Component}`}>
    </div>
  );
};

export default H5Component;
